/* Error message constants for bulk update modal */
export const FILE_FORMAT = "Invalid File Format";
export const FILE_SIZE = "Invalid File Size";
export const EXCEL_FORMAT_ERR = "Please upload a valid CSV file";
export const EXCEL_UPLOAD_MAX_ERR_MSG = "Please upload a file smaller than 25 MB";

export const EXCEL_Template = "Invalid Excel Template";
export const EXCEL_EMPTY_ERR_MSG = "Uploaded file has no valid data rows";
export const HEADER_ERR = "Invalid Header";
export const HEADER_ERR_MESSAGE = "Please upload file with valid headers";

export const EMPTY_VALUE = "Empty Value Error";
export const EMPTY_VALUE_1 = "Empty values found in row";
export const EMPTY_VALUE_2 = ". Please fill all mandatory columns";

export const INVALID_CHAR_1 = "Invalid characters found in row";
export const INVALID_CHAR_2 = ". Please check and re-upload";

export const DUPLICATE_DATA = "Duplicate Data Error";
export const DUPLICATE_DATA_2 = ". Duplicate rows are not allowed";

export const BAD_REQUEST = "Bad Request";
export const NO_RESPONSE_ERROR = "No response received from server";